import React from "react";
import { useAuth } from "./../util/auth";

function SettingsGeneral(props) {
  const auth = useAuth();

  return (
    <div className="space-y-4">
      <div className="w-full">
        <label className="block mb-1 font-medium" htmlFor="email">
          Email
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={auth.user.email}
          readOnly
          className="block border placeholder-gray-400 w-full rounded border-gray-200 bg-gray-50 px-4 py-3 leading-6"
        />
      </div>
    </div>
  );
}

export default SettingsGeneral;
